import React from 'react';
import classes from './style.module.scss';
import useTranslation from '~/app/hooks/useTranslation';

export type HeaderProps = {
    mode: 'add' | 'edit';
};

export type HeaderComponent = React.FC<HeaderProps>;

const Header: HeaderComponent = ({ mode }) => {
    const { t } = useTranslation('workorder');
    return (
        <div className={classes['model-header']}>
            <div className={classes['header-content']}>
                <label className={classes['title']}>
                    {mode === 'edit' ? t('detail.timeEntryEditTitle') : t('detail.timeEntryAddTitle')}
                </label>
            </div>
        </div>
    );
};

export default Header;
